import Image from "components/Elements/Image/Image.tsx";
import Icon from "components/Elements/Icon/Icon.tsx";
import useScrollTrigger from "../../../hooks/useScrollTrigger.js";
import useOrganization from "hooks/useOrganization.ts";
import useMediaQueries from "hooks/useMediaQueries.js";
import checkCurrDomainIsOrgDomain from "helpers/checkCurrDomainIsOrgDomain.ts";

import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { LinkToNewTab } from "../../Elements/Link/Link.js";
import { useEffect } from "react";

const isCustomDomain = checkCurrDomainIsOrgDomain();

export const GeneralLinks = ({
  direction,
  whiteLogo,
  openDropdown,
  closeDropdown,
  shownSection,
  isCustomHeader,
}) => {
  const {
    getTextByKey,
    getBlackFridayTime,
    getBlackFridayTimeCookie,
    getDirection,
  } = useContent();
  const { moreThanNumber, scrolledUp } = useScrollTrigger(700);
  const classes = "links links-" + direction;
  const lastUrlSegment = window.location.pathname.split("/").pop();
  const { tabletCondition } = useMediaQueries();

  const { logo, fetchLogo, checkCurrDomainIsOrgDomain } = useOrganization();

  useEffect(() => {
    fetchLogo();
  }, []);

  return (
    <div className={classes}>
      <LinkToNewTab exact page={"home"} classes={"no-hover"}>
        {logo ? (
          <Image src={logo} className="custom-logo" />
        ) : checkCurrDomainIsOrgDomain() ? null : (
          <Image
            name={
              !whiteLogo ||
              (moreThanNumber && scrolledUp) ||
              direction === "column"
                ? "jumbomail-logo-black"
                : "jumbomail-logo"
            }
            title="JUMBOmail"
            alt="JUMBOmail"
          />
        )}
      </LinkToNewTab>
      {isCustomHeader || isCustomDomain ? null : (
        <>
          {!tabletCondition && (
            <LinkToNewTab
              exact
              page={"home"}
              ariaLabel={getTextByKey("send-files-now")}
            >
              {getTextByKey("send-files-now")}
            </LinkToNewTab>
          )}
          <LinkToNewTab
            page="features"
            classes={`${
              shownSection === "features" ? "mega-menu-opened-item" : null
            }`}
            onMouseOver={() => openDropdown("features")}
            onMouseLeave={closeDropdown}
          >
            {getTextByKey("features")}
            <Icon name="arrow-down" small gray iconClass="dropdown-item-icon" />
            {lastUrlSegment === "features" && <div className="active-header" />}
          </LinkToNewTab>
          <LinkToNewTab
            page="for-businesses"
            classes={`${
              shownSection === "for-businesses" ? "mega-menu-opened-item" : null
            }`}
            onMouseOver={() => openDropdown("for-businesses")}
            onMouseLeave={closeDropdown}
          >
            {getTextByKey("for-businesses")}
            <Icon name="arrow-down" small gray iconClass="dropdown-item-icon" />
            {lastUrlSegment === "for-businesses" && (
              <div className="active-header" />
            )}
          </LinkToNewTab>
          <LinkToNewTab page="plans">
            {getTextByKey("plans")}
            {getBlackFridayTime() && !getBlackFridayTimeCookie() ? (
              <div className="promo-sale-tag">
                <Image name="black-friday/logo_lable" />
              </div>
            ) : null}
            {lastUrlSegment === "plans" && <div className="active-header" />}
          </LinkToNewTab>
          <LinkToNewTab
            exact
            page={"advertising"}
            ariaLabel={getTextByKey("advertising")}
          >
            {getTextByKey("advertising")}
            <div className={"new-page-label"}>
              <Image
                name={`new-page-label${getDirection() === "ltr" ? "" : "-he"}`}
                ext="svg"
              />
            </div>
            {lastUrlSegment === "advertising" && (
              <div className="active-header" />
            )}
          </LinkToNewTab>
        </>
      )}
    </div>
  );
};
